import { GigyaResponse } from './gigya-response';

export interface GigyaFullAccountResponse extends GigyaResponse {
  data: {
    isAvailable: boolean;
    loginProviders: string;
    socialProviders: string;
  };
}
